import { render, staticRenderFns } from "./configPage.vue?vue&type=template&id=b7a5699c&scoped=true"
import script from "./configPage.vue?vue&type=script&lang=js"
export * from "./configPage.vue?vue&type=script&lang=js"
import style0 from "./configPage.vue?vue&type=style&index=0&id=b7a5699c&prod&lang=scss&scoped=true"
import style1 from "./configPage.vue?vue&type=style&index=1&id=b7a5699c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a5699c",
  null
  
)

export default component.exports